export enum BKEventName {
  PortalWebException = 'portal_web_exception',
}

export interface IBKEventData extends Record<string, string> {
  readonly content: string;
}

export enum BKErrorLevel {
  Fatal = 'fatal',
  Warn = 'warn',
  Info = 'info',
}

export interface IBKDimension {
  readonly path: string;
  readonly userID: string;
  readonly location: string;
  readonly module: 'web';
  readonly level?: BKErrorLevel;
}

export interface IBKEvent {
  readonly event_name: BKEventName;
  readonly event: { content: string };
  readonly dimension: IBKDimension;
  readonly target?: string;
  readonly timestamp: number;
}

export interface IBKMetric {
  readonly metrics: {
    dev_portal_page_time_cost: number;
  };
  readonly dimension: IBKDimension;
  readonly target?: string;
  readonly timestamp: number;
}

export enum IBKReportType {
  Event = 'event',
  Metric = 'metric',
}

export interface IBKReportErrorBody {
  type: IBKReportType;
  data: ReadonlyArray<IBKEvent>;
}

export interface IBKReportTimeCostBody {
  type: IBKReportType;
  data: ReadonlyArray<IBKMetric>;
}
